import { getCookie } from "utils/persistor";

export const getInitialLocale = () => {
  const clientLocale = getCookie("raychat_webapp_client_locale");
  const serverLocale = getCookie("raychat_webapp_server_locale");

  if (clientLocale) return clientLocale;
  if (serverLocale) return serverLocale;

  return "fa";
};
